/* unplugin-vue-components disabled */import script from "./Tech.vue?vue&type=script&setup=true&lang=js"
export * from "./Tech.vue?vue&type=script&setup=true&lang=js"

import "./Tech.vue?vue&type=style&index=0&id=54ad27f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ad27f3"]])

export default __exports__